import { styled } from '@material-ui/core';

/** @deprecated Legacy MUI copy — migrate consumers to the Encore HeaderContent and delete. */
export const HeaderContentMui = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  paddingLeft: theme.spacing(2),
  marginLeft: 'auto',
}));
